import React from 'react';
import { motion } from 'framer-motion';
import { Users, Activity, Target, Trophy } from 'lucide-react';

export function TrainerStats() {
  const stats = [
    {
      label: 'Active Clients',
      value: '24',
      change: '+3',
      trend: 'up',
      icon: <Users className="w-4 h-4" />,
      color: 'primary'
    },
    {
      label: 'Client Retention',
      value: '92%',
      change: '+2%',
      trend: 'up',
      icon: <Activity className="w-4 h-4" />,
      color: 'success'
    },
    {
      label: 'Goal Completion',
      value: '87%',
      change: '+5%',
      trend: 'up',
      icon: <Target className="w-4 h-4" />,
      color: 'primary'
    },
    {
      label: 'Client Progress',
      value: '78%',
      change: '+8%',
      trend: 'up',
      icon: <Trophy className="w-4 h-4" />,
      color: 'success'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              {stat.icon}
              <span>{stat.label}</span>
            </div>
            <div className="text-2xl font-bold">{stat.value}</div>
            <div className="flex items-center gap-1 text-xs text-success mt-1">
              <Activity className="w-3 h-3" />
              <span>{stat.change} this month</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}